<ng-container *ngrxLet="command() as currentCommand">
    <div class="st-insert-take-command-dialog__line">
        <st-combo-box
            st-click-stop-propagation
            shouldHaveFilter="false"
            [addEmptyOption]="false"
            [value]="currentCommand[ProductionFieldName.OPTION]"
            [label]="ProductionCommandsDefaultLabels[ProductionFieldName.OPTION]"
            [itemList]="ProductionCommandsObjectOptions"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.OPTION)" />
        <st-text-field
            showLinks
            [value]="currentCommand[ProductionFieldName.OPTION_DESCRIPTION]"
            [label]="currentCommand[ProductionFieldName.OPTION]"
            (onEnter)="saveCommand($event, ProductionFieldName.OPTION_DESCRIPTION)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.OPTION_DESCRIPTION)" />
    </div>
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.NAME]"
        [label]="ProductionCommandsDefaultLabels[ProductionFieldName.NAME]"
        (onEnter)="saveCommand($event, ProductionFieldName.NAME)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.NAME)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.NUMBER]"
        [label]="ProductionCommandsDefaultLabels[ProductionFieldName.NUMBER]"
        (onEnter)="saveCommand($event, ProductionFieldName.NUMBER)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.NUMBER)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.INCUE]"
        [label]="ProductionCommandsDefaultLabels[ProductionFieldName.INCUE]"
        (onEnter)="saveCommand($event, ProductionFieldName.INCUE)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.INCUE)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.OUTCUE]"
        [label]="ProductionCommandsDefaultLabels[ProductionFieldName.OUTCUE]"
        (onEnter)="saveCommand($event, ProductionFieldName.OUTCUE)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.OUTCUE)" />

    <div class="st-insert-take-command-dialog__at-to">
        <st-duration-seconds-input-field
            showLinks
            [label]="ProductionCommandsDefaultLabels[ProductionFieldName.AT]"
            [value]="currentCommand[ProductionFieldName.AT]"
            (onEnter)="saveCommand($event, ProductionFieldName.AT)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.AT)" />
        <st-duration-seconds-input-field
            showLinks
            [label]="ProductionCommandsDefaultLabels[ProductionFieldName.TO]"
            [value]="currentCommand[ProductionFieldName.TO]"
            (onEnter)="saveCommand($event, ProductionFieldName.TO)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.TO)" />
    </div>

    <div class="st-insert-take-command-dialog__type-content">
        <mat-radio-group
            class="st-insert-take-command-dialog__type-content__radio-group"
            [value]="currentCommand[ProductionFieldName.TIME_FIELD]"
            (keyup)="onKeyup($event, ProductionFieldName.TIME_FIELD)"
            (change)="onCommandsObjectChange($event?.value, ProductionFieldName.TIME_FIELD)">
            <mat-radio-button [value]="ProductionFieldName.DURATION">{{ ProductionCommandsDefaultLabels[ProductionFieldName.DURATION] }}</mat-radio-button>
            <mat-radio-button [value]="ProductionFieldName.ITEM_TIME">{{ ProductionCommandsDefaultLabels[ProductionFieldName.ITEM_TIME] }}</mat-radio-button>
        </mat-radio-group>

        <st-duration-seconds-input-field
            [value]="currentCommand[ProductionFieldName.TIME_VALUE]"
            (onEnter)="saveCommand($event, ProductionFieldName.TIME_VALUE)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.TIME_VALUE)" />
    </div>
</ng-container>
